// extracted by mini-css-extract-plugin
var _1 = "GroupUserCard-module__animateUploadProgressBarWidth--D_Zuj";
var _2 = "GroupUserCard-module__animatedBackground--lB56n";
var _3 = "GroupUserCard-module__name--uUL_c";
var _4 = "GroupUserCard-module__title--qYDlB";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "name", _4 as "title" }
